import axios from 'axios';
import { isAdmin, isSuperAdmin } from '../../../utils/appUtils';
import { CREATE_MESSAGE } from '../../constants';

export const createMessage = (data, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadCreateMessage());
  let url = 'message/create';
  axios
    .post(url, data, config)
    .then((res) => dispatch(setCreateMessage(res.data.data)))
    .catch((err) => {
      dispatch(errorCreateMessage(err.response));
      onError(err.response);
    });
};

export const loadCreateMessage = () => ({
  type: CREATE_MESSAGE.LOAD,
});

export const setCreateMessage = (countData) => ({
  type: CREATE_MESSAGE.SUCCESS,
  payload: countData,
});

export const errorCreateMessage = (error) => ({
  type: CREATE_MESSAGE.FAIL,
  payload: error,
});
